import 'reactjs-popup/dist/index.css';

import classNames from 'classnames';
import React from 'react';
import Popup from 'reactjs-popup';

import popupStyles from './Popup.scss';

export const messageLevel = Object.freeze({
  WARN: 'warn',
  ERROR: 'error',
  INFO: 'info',
});

interface Message {
  content?: JSX.Element | string;
  level: 'warn' | 'error' | 'info' | 'ERROR' | 'WARN' | 'INFO';
}
interface MessagePopupProps {
  message?: Message | null;
  toggleMessage: (arg: any) => void;
  contentStyle?: string;
  buttons?: (close: () => void) => JSX.Element;
}
export default class MessagePopup extends React.Component<MessagePopupProps> {
  render() {
    const { message, toggleMessage, contentStyle, buttons } = this.props;

    const level = (() => {
      if (message == null) {
        return undefined;
      }

      switch (message.level) {
      case 'ERROR':
        return messageLevel.ERROR;
      case 'WARN':
        return messageLevel.WARN;
      case 'INFO':
        return messageLevel.INFO;
      default:
        return message.level ?? 'info';
      }
    })();
    const content = message == null ? undefined : message.content;
    const header = (() => {
      switch (level) {
      case messageLevel.WARN:
        return 'Warning';
      case messageLevel.ERROR:
        return 'Error';
      case messageLevel.INFO:
      default:
        return 'Information';
      }
    })();

    return (
      <Popup
        modal
        open={content != null}
        onClose={() => toggleMessage(null)}
      >
        {(close: () => void) => (
          <div>
            <div className={popupStyles.header}><span className={popupStyles[level]}></span>{header}</div>
            <div className={classNames(popupStyles.content, contentStyle)}>
              {content}
            </div>
            <div className={popupStyles.buttons}>
              {buttons == null ?
                <div onClick={close}>Close</div>
                :
                buttons(close)
              }
            </div>
          </div>
        )}
      </Popup>
    );
  }
}
